import axios from 'axios';
import ReduxStore from '../ReduxStore';
import {updateUploadProgress} from 'ducks/uploadProgress';

export function uploadDigitalAsset(payload, updateProgress = true) {
  const data = new FormData();
  data.append('file', payload.file);
  const url = `/api/uploadDigitalAsset?source=${payload.source}&propertyId=${payload.propertyId}`;
  return axios.post(url, data, {
    headers: {'Accept': 'application/json'},
    onUploadProgress: (progressEvent) => {
      if (updateProgress) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        ReduxStore.dispatch(updateUploadProgress(percentCompleted));
      }
    }
  });
}

export function deleteAsset(url) {
  return axios.delete('/api/digitalAsset', {data: url});
}

export const convertToReadUrl = function (uploadUrl) {
  return uploadUrl.split('?')[0];
};
